/**
 * Lazy Sizes
 * 
 * @link https://github.com/aFarkas/lazysizes
 * 
 */
import 'lazysizes';
import 'lazysizes/plugins/object-fit/ls.object-fit';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import 'lazysizes/plugins/blur-up/ls.blur-up';
import 'lazysizes/plugins/unveilhooks/ls.unveilhooks';
import lightbox from 'lightbox2';

function initialiseLightbox() {

    const galleryItems = document.querySelectorAll('.gallery .gallery-item a');
    galleryItems.forEach((item, index) => {
        item.setAttribute('data-lightbox', 'gallery');
        const figcaption = item.closest('.gallery-item').querySelector('figcaption');
        const caption = figcaption ? figcaption.textContent.trim() : '';
        if (caption) {
            item.setAttribute('data-title', caption);
        }
    });

    lightbox.option({
        'resizeDuration': 100,
        'wrapAround': true,
        'alwaysShowNavOnTouchDevices': false,
        'albumLabel': 'Image %1 of %2',
    });
}

document.addEventListener('DOMContentLoaded', function() {
    console.log('Images module loaded');
    initialiseLightbox();

})


